import Repeat from '../../../../../shared/components/Repeat';

import { SkeletonWrapper } from './styled-components';
import SkeletonLoading from '../../../../../shared/components/Loading/SkeletonLoading';

const Loading = ({ count }: { count: number }) => (
  <Repeat count={count}>
    <SkeletonWrapper>
      <SkeletonLoading width={124} height={124} radius={0} />
    </SkeletonWrapper>
  </Repeat>
);

export default Loading;
